
import { Link } from 'react-router-dom';

export default function PortalFooter() {
  return (
    <footer className="bg-[#060e1a] mt-auto">
      <div className="max-w-7xl mx-auto px-8 py-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/40">
          <div className="flex items-center gap-4">
            <img
              src="https://static.readdy.ai/image/8dbd60c8f218d42716666e4ddaa548a8/e10d3fd4f000823b1408934f8a9fe8ab.png"
              alt="AMM Management Group Logo"
              className="h-8 w-auto opacity-60"
            />
            <span>{'©'} 2024 AMM Management Group. All rights reserved.</span>
          </div>
          <div className="flex gap-6">
            <a
              href="tel:7147669527"
              className="hover:text-[#00e5c7] transition-colors cursor-pointer"
            >
              (714) 766-9527
            </a>
            <a
              href="mailto:monge.alejandro.tax@gmail.com"
              className="hover:text-[#00e5c7] transition-colors cursor-pointer"
            >
              monge.alejandro.tax@gmail.com
            </a>
            <Link
              to="/"
              className="hover:text-[#00e5c7] transition-colors cursor-pointer"
            >
              Main Website
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
